var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponGreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#couponGreenClip)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "coupon-green-icon",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.25C0 1.00736 0.984974 0 2.2 0H19.8C21.01 0 22 1.00125 22 2.25V6.75C20.79 6.75 19.8 7.75125 19.8 9C19.8 10.2426 20.785 11.25 22 11.25V15.75C22 16.9926 21.015 18 19.8 18H2.2C0.984974 18 0 16.9926 0 15.75V11.25C1.21503 11.25 2.2 10.2426 2.2 9C2.2 7.7625 1.221 6.75 0 6.75V2.25ZM7.02042 5.75C7.02042 4.7835 7.80392 4 8.77042 4C9.73691 4 10.5204 4.7835 10.5204 5.75C10.5204 6.7165 9.73691 7.5 8.77042 7.5C7.80392 7.5 7.02042 6.7165 7.02042 5.75ZM12.1224 12.5612C12.1224 11.5947 12.9059 10.8112 13.8724 10.8112C14.8389 10.8112 15.6224 11.5947 15.6224 12.5612C15.6224 13.5277 14.8389 14.3112 13.8724 14.3112C12.9059 14.3112 12.1224 13.5277 12.1224 12.5612ZM7.43878 14.0207L16.2041 5.66249L14.7653 4.29053L6 12.6488L7.43878 14.0207Z",
    fill: "#5D6B72"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#coupon-green-icon)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -3,
    width: 24,
    height: 24,
    fill: "#54AF48"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "couponGreenClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white",
    transform: "translate(-654 -185)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponGreenIcon);
export default __webpack_public_path__ + "static/media/CouponGreenIcon.a6fdb8ee.svg";
export { ForwardRef as ReactComponent };